module.exports = __webpack_public_path__ + "0ffcb1e23466624be646c1f008ca6879.mp4";